import React, { useState } from 'react';
import styled from 'styled-components';
import MobileCategory from './MobileCategory';

const StyledBurger = styled.div`
  width: 2rem;
  height: 25px;
  position: fixed;
  top: 25px;
  left: 20px;
  z-index: 20;
  display: none;
  @media (max-width: 768px) {
    display: flex;
    justify-content: space-around;
    flex-flow: column nowrap;
    position: absolute;
    cursor:pointer;
  }
  div {
    width: 25px;
    height: 2px;
    background-color: ${({ open }) => open ? '#3b3b3b' : '#fff'};
    border-radius: 10px;
    transform-origin: 1px;
    transition: all 0.3s linear;
    &:nth-child(1) {
      transform: ${({ open }) => open ? 'rotate(45deg)' : 'rotate(0)'};
    }
    &:nth-child(2) {
      transform: ${({ open }) => open ? 'translateX(100%)' : 'translateX(0)'};
      opacity: ${({ open }) => open ? 0 : 1};
    }
    &:nth-child(3) {
      transform: ${({ open }) => open ? 'rotate(-45deg)' : 'rotate(0)'};
    }
  }
`;

const Burger = () => {
  const [open, setOpen] = useState(false)
    const openTab = () =>{
        setOpen(false)
    }
  return (
    <>
      <StyledBurger open={open} onClick={() => setOpen(!open)}>
        <div />
        <div />
        <div />
      </StyledBurger>
      <MobileCategory open={open} openTab={openTab}/>
    </>
  )
}

export default Burger;